import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

export const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'user-management',
        canActivate: [permissionGuard(['user', 'role', 'activity_log'])],
        loadChildren: () =>
          import('./features/user-management/user-management.routes').then(
            m => m.userManagementRoutes,
          ),
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'chart-of-accounts',
        canActivate: [permissionGuard('chart_of_accounts')],
        loadComponent: () =>
          import('./features/chart-of-accounts/chart-of-accounts.component').then(
            m => m.ChartOfAccountsComponent,
          ),
      },
      {
        path: 'chart-of-accounts/dimension-view',
        canActivate: [permissionGuard('chart_of_accounts')],
        loadComponent: () =>
          import('./features/chart-of-accounts/chart-of-accounts.component').then(
            m => m.ChartOfAccountsComponent,
          ),
      },
      {
        path: 'chart-of-accounts/:id/documents',
        canActivate: [permissionGuard('chart_of_accounts')],
        data: { mode: 'coa' },
        loadComponent: () =>
          import('./features/masters/components/document-management-page/document-management-page').then(
            m => m.DocumentManagementPage,
          ),
      },
      {
        path: 'journal-entries',
        canActivate: [permissionGuard('journal_entry')],
        loadComponent: () =>
          import('./features/journal-entries/journal-entries.component').then(
            m => m.JournalEntriesComponent,
          ),
      },
      {
        path: 'trial-balance',
        canActivate: [permissionGuard('test_balance')],
        loadComponent: () =>
          import('./features/trial-balance/trial-balance.component').then(
            m => m.TrialBalanceComponent,
          ),
      },
      {
        path: 'reinsurance-calculations',
        canActivate: [permissionGuard('reinsurance')],
        loadComponent: () =>
          import('./features/reinsurance-calculations/reinsurance-calculations.component').then(
            m => m.ReinsuranceCalculationsComponent,
          ),
      },
      {
        path: 'masters',
        canActivate: [
          permissionGuard([
            'treaty',
            'mga',
            'class_of_business',
            'coverage',
            'state',
            'reinsurer',
            'carrier',
            'broker',
            'tpa',
            'product',
            'masters_config',
            'treaty_type',
            'gl_mapping',
          ]),
        ],
        loadChildren: () => import('./features/masters/masters.routes').then(m => m.mastersRoutes),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'auth/login' },
];
